module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-holidays@2-88c4e072dd2d115127581fc279873de8.jpg";